<template>
  <va-edit-layout :actions="['list', 'show', 'delete']">
    <croppings-form :id="id" :title="title" :item="item"></croppings-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ['id', 'title', 'item'],
}
</script>
